import { Config } from "./base";

const config: Config = {
  environment: "production",
  api: {
    endpoint: "https://me-eu.api.atlas.minimum.com",
    disableCache: false,
  },
  sentry: {
    dsn: "https://28e806a01a58ae060089ac0e87c6b72a@o346449.ingest.us.sentry.io/4507900069412864",
    project: "atlas-dashboard-production-me",
  },
  auth0: {
    clientId: "XsD7QE3ASC8juTYXsRpD3RUjxNvHLdGn",
    domain: "me.auth.minimum.com",
    redirectUrl: "https://me-eu.dashboard.minimum.com/auth/callback",
  },
  app: {
    sem_ver: process.env.APP_VERSION,
    name: process.env.APP_NAME,
  },
  segment: {
    writeKey: "jonLKb2slE3PDYJRJ3pv3pCzBzwRFuBb",
    cdn: "https://analytics-a.minimum.eco",
  },
  formbricks: {
    environmentId: "clzww7ji90009d5knsl79eqcx",
    apiHost: "https://formbricks.novisto.net",
  },
  supportEmail: "support@minimum.com",
  features: {
    TESTING_FEATURES: false,
  },
};

export type { Config };
export default config;
